export function sellerAdvisoryCommercialCP826() {
return [   // Release 2026-09-08 17:30:48
 
{
   page: 0,
   name: "Agent Brokerage Firm Name 1", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 47.4,
   left: 159.36,
   width: 378.84,
   height: 11.16
}
,
{
   page: 0,
   name: "Seller", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 143.64,
   left: 180.12,
   width: 356.16,
   height: 11.16
}
,
{
   page: 0,
   name: "Address Full", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 170.64,
   left: 180.12,
   width: 356.16,
   height: 11.16
}
,
{
   page: 0,
   name: "Agent Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 197.4,
   left: 180.12,
   width: 356.16,
   height: 11.16
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 224.4,
   left: 180.12,
   width: 356.16,
   height: 11.16
}
,
{
   page: 0,
   name: "Agent Brokerage Firm Name 2", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 3", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.84,
   height: 10.08
}
,
{
   page: 1,
   name: "Agent Brokerage Firm Name 4", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 5", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.84,
   height: 10.08
}
,
{
   page: 2,
   name: "Agent Brokerage Firm Name 6", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 7", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 48.48,
   left: 159.36,
   width: 378.84,
   height: 10.08
}
,
{
   page: 3,
   name: "Agent Brokerage Firm Name 8", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 9", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 47.4,
   left: 159.36,
   width: 378.84,
   height: 11.16
}
,
{
   page: 4,
   name: "Signature Seller Broker", 
   type: "signature",
   fontName: "Times New Roman",
   fontSize: 9,
   top: 641.345,
   left: 72.0,
   width: 378.24,
   height: 15.055
}
,
{
   page: 4,
   name: "Date Signature Seller Broker", 
   fontSize: 9,
   type: "date",
   top: 640.691,
   left: 455.4,
   width: 76.8,
   height: 15.709
}
,
{
   page: 4,
   name: "Agent Brokerage Firm Name 10", 
   type: "text",
   fontName: "Times New Roman",
   fontSize: 7,
   top: 744.48,
   left: 73.08,
   width: 300.48,
   height: 10.08
}
] }
